import {Component, ComponentFactoryResolver, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';

import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { Dac6CellEditorContainerComponent } from '../dac6-cell-editor-container/dac6-cell-editor-container.component';
import { CellComponent } from '@shared/components/cell-components/cell-component';
import { FieldDefinition } from '@shared/models/field-definition';
import { CellDecoratorHostDirective } from '@shared/directive/cell-decorator-host.directive';
import { ParticleService } from '@core/services/particle.service';
import { ParticleState } from '@shared/store/reducers/particle.reduer';
import { CellEditorData } from '@shared/models/cell-editor-data.model';
import { CellEditorActionData } from '@shared/models/cell-editor-action-data.model';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';


@Component({
    standalone: false,
    selector: 'lib-dac6-cell-decorator',
  templateUrl: './dac6-cell-decorator.component.html',
  styleUrls: ['./dac6-cell-decorator.component.scss']
})
export class Dac6CellDecoratorComponent implements OnInit, CellComponent {
  invalidateSubject?: InvalidateSubject;
  fieldDefinition: FieldDefinition;
  item: any;
  sourceType: string;
  valueChanged: EventEmitter<any> = new EventEmitter();
  isMouseOver = false;
  disabled: boolean;
  private panelClass: string;

  @ViewChild(CellDecoratorHostDirective, {static: true}) particleCellDecoratorHost: CellDecoratorHostDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private particleService: ParticleService,
              private particleStore: Store<ParticleState>,
              private matDialog: MatDialog) { }

  ngOnInit() {
    this.renderCell();
  }

  renderCell () {
    const currentComponent = this.particleService.getCellComponent(this.fieldDefinition.cellViewer);
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(currentComponent);
    this.particleCellDecoratorHost.viewContainerRef.clear();
    const component = this.particleCellDecoratorHost.viewContainerRef.createComponent(currentComponent);
    const cellComponent = component.instance as CellComponent;
    cellComponent.item = this.item;
    cellComponent.fieldDefinition = this.fieldDefinition;
    if (cellComponent.valueChanged) {
      cellComponent.valueChanged.subscribe(value => this.valueChanged.emit(value));
    }
    cellComponent.sourceType = this.sourceType;
  }

  showCellEditor () {
    if (this.fieldDefinition.cellEditor) {
      this.panelClass = this.fieldDefinition.cellEditor === 'OwnershipCellEditor' ? 'full-screen-modal' : '';
      this.matDialog.open(Dac6CellEditorContainerComponent, {
        panelClass: this.panelClass,
        data: <CellEditorData> {
          fieldDefinition: this.fieldDefinition,
          item: this.item,
          sourceType: this.sourceType
        }
      }).afterClosed().subscribe((result: CellEditorActionData) => {
        if(result && result.clickedButtonName === 'Ok' && result.data.fieldDefinition.key === 'Ownership'){
          this.invalidateSubject.invalidate();
        }
      });
    }
  }
}
